export enum IndexedDbStores {
    TERMINAL_LOGS = 'terminal_logs',
    PRINTER_QUEUE = 'printer_queue',
    BULK_FAILSAFE_RESPONSES = 'bulk_failsafe_responses',

    //unused (should be updated/removed)
    TRANSACTIONS_IN_PROGRESS = 'transactions_in_progress',
}

const DB_NAME = 'main';
const DB_VERSION = 4;
let dbOpenTask: Promise<IDBDatabase> | undefined = undefined;

export async function getConnection(): Promise<IDBDatabase> {
    if (dbOpenTask === undefined) {
        dbOpenTask = new Promise((resolve, reject) => {
            if (!indexedDB) {
                reject('indexedDB not supported');
            }
            const request = indexedDB.open(DB_NAME, DB_VERSION);
            request.onerror = () => {
                console.warn('failed connection to indexed db');
                reject('failed connection to indexed db');
            };

            request.onsuccess = () => {
                console.log('successfully connected to indexed db');
                resolve(request.result);
            };

            request.onupgradeneeded = (event: any) => {
                const db = event.target.result;
                if (!event.target.result.objectStoreNames.contains(IndexedDbStores.TERMINAL_LOGS)) {
                    db.createObjectStore(IndexedDbStores.TERMINAL_LOGS, { keyPath: 'id', autoIncrement: true });
                }
                if (!event.target.result.objectStoreNames.contains(IndexedDbStores.BULK_FAILSAFE_RESPONSES)) {
                    db.createObjectStore(IndexedDbStores.BULK_FAILSAFE_RESPONSES, { keyPath: 'id' });
                }
                if (!event.target.result.objectStoreNames.contains(IndexedDbStores.TRANSACTIONS_IN_PROGRESS)) {
                    db.createObjectStore(IndexedDbStores.TRANSACTIONS_IN_PROGRESS, { keyPath: 'id' });
                }
                if (!event.target.result.objectStoreNames.contains(IndexedDbStores.PRINTER_QUEUE)) {
                    db.createObjectStore(IndexedDbStores.PRINTER_QUEUE, { keyPath: 'relevantUntil' });
                }
            };
        });
    }
    return dbOpenTask;
}

export async function getStoreConnection(
    storeName: string,
    mode?: IDBTransactionMode | undefined,
    options?: IDBTransactionOptions | undefined
): Promise<IDBObjectStore> {
    const connection = await getConnection();
    return connection.transaction(storeName, mode, options).objectStore(storeName);
}
